import React from 'react';
import Drawer, { FooterSpacer } from '../Drawer';
import Button from '../Button';
import Field from '../Field';
import {
  REPERTOIRE_STATUSES, REPERTOIRE_TITLE_MAX, repertoireCanSave, repertoireTitleError,
} from '../../domain/repertoire';
import s from './drawers.module.css';

export default function RepertoirePieceDrawer({ open, form, onChange, onClose, onSave }) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Add Repertoire"
      width={520}
      footer={(
        <>
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <FooterSpacer />
          <Button disabled={!repertoireCanSave(form.title)} onClick={onSave}>Save</Button>
        </>
      )}
    >
      <div className={s.section}>
        <Field label="Title" required error={repertoireTitleError(form.title)}>
          <input className={s.input} value={form.title} maxLength={REPERTOIRE_TITLE_MAX}
                 onChange={(e) => onChange({ title: e.target.value })} />
        </Field>
      </div>
      <div className={s.pair} style={{ marginTop: 12 }}>
        <Field label="Composer" hint="Optional">
          <input className={s.input} value={form.composer}
                 onChange={(e) => onChange({ composer: e.target.value })} />
        </Field>
        <Field label="Status">
          <select className={s.input} value={form.status}
                  onChange={(e) => onChange({ status: e.target.value })}>
            {REPERTOIRE_STATUSES.map((st) => <option key={st.id} value={st.id}>{st.label}</option>)}
          </select>
        </Field>
      </div>
    </Drawer>
  );
}
